import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { colors } from 'src/global/styles/colors';

const breadcrumbsMap: Record<string, string[]> = {
  '/core-sale': [],
  '/core-sale/create': ['Collection', 'Create a Collection'],
  '/core-sale/:id/edit': ['Collection', 'Collection Program Details'],
  '/core-sale/:id/edit/otc/:otcId': ['Collection', 'Collection Program Details', 'OTC Sale Details'],
  '/core-sale/approve': [],
  '/core-sale/:id/approve': ['Collection', 'Collection Program Details'],
};

const BreadcrumbsComponent: React.FC = () => {
  const nagivate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;

  const matchPath = () => {
    const pathSegments = pathname.split('/');

    for (const key in breadcrumbsMap) {
      const keySegments = key.split('/');
      if (
        pathSegments.length === keySegments.length &&
        keySegments.every((seg, i) => seg === pathSegments[i] || seg.startsWith(':'))
      ) {
        return breadcrumbsMap[key];
      }
    }
    return null;
  };

  const breadcrumbItems = matchPath();

  if (!breadcrumbItems || breadcrumbItems.length === 0) {
    return null;
  }

  const handleBreadcrumbClick = (index: number) => {
    const isCreatorPage = pathname.includes('/edit') || pathname.includes('/create');
    const isVotingPage = pathname.includes('/approve');

    if (index === 0 && isCreatorPage) {
      nagivate('/core-sale');
    } else if (index === 0 && isVotingPage) {
      nagivate('/core-sale/approve');
    }
  };

  return (
    <Breadcrumbs aria-label='breadcrumb' separator='/' sx={{ color: 'white' }}>
      {breadcrumbItems.map((item, index) => {
        const isLast = index === breadcrumbItems.length - 1;
        const label = item;

        return isLast ? (
          <Typography
            sx={{
              cursor: 'pointer',
            }}
            key={item}
            color={colors.neutral015}>
            {label}
          </Typography>
        ) : (
          <Typography
            key={item}
            color={'white'}
            sx={{
              cursor: 'pointer',
              '&:hover': {
                color: 'white',
              },
            }}
            onClick={() => handleBreadcrumbClick(index)}>
            {label}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );
};

export default BreadcrumbsComponent;
